// [Archies] Sticky Add-to-cart bar controller (snippets/sticky-atc-ext.liquid).
// Reveals the fixed bottom bar once the section's REAL add-to-cart button has scrolled up out of
// view, and hides it again when the real ATC is back on screen. The bar's button is an in-page link
// that smooth-scrolls back to the real ATC (and focuses it) — it never adds to cart itself, so the
// product's "select a size" gate is always honoured. Serves both the PDP and the page Buy Box.

if (!window.__archiesStickyAtcWired) {
  window.__archiesStickyAtcWired = true;

  const SECTION_SELECTOR = '.product-information, .product-buy-box-ext';
  const prefersReduced = () =>
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const wire = (bar) => {
    if (bar.__wired) return;
    bar.__wired = true;

    // Scope to the section this bar belongs to, then find its real ATC button.
    const root = bar.closest(SECTION_SELECTOR) || document;
    const atc =
      root.querySelector('.add-to-cart-button') ||
      root.querySelector('add-to-cart-component') ||
      root.querySelector('[ref="addToCartButton"]');
    if (!atc) return;

    // Re-parent to <body> so position:fixed always anchors to the viewport — a transform/filter on any
    // ancestor section would otherwise turn it into the containing block and break the sticky bar.
    if (bar.parentElement !== document.body) {
      document.body.appendChild(bar);
    }

    // Show the bar only while the real ATC sits ABOVE the viewport (scrolled past going down);
    // hide while it's visible or still below (not reached yet).
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          bar.classList.toggle('sticky-atc-ext--visible', scrolledPast);
        }
      },
      { threshold: 0 }
    );
    observer.observe(atc);

    // Scroll back to the real ATC + focus it (keyboard users). Progressive enhancement over the
    // anchor href, which already scrolls without JS.
    const link = bar.querySelector('[data-sticky-atc-scroll]');
    if (link) {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        atc.scrollIntoView({
          behavior: prefersReduced() ? 'auto' : 'smooth',
          block: 'center',
        });
        const focusTarget =
          atc.matches && atc.matches('button, a') ? atc : atc.querySelector('button, a');
        if (focusTarget) {
          window.setTimeout(
            () => {
              try {
                focusTarget.focus({ preventScroll: true });
              } catch (e) {
                focusTarget.focus();
              }
            },
            prefersReduced() ? 0 : 450
          );
        }
      });
    }
  };

  const init = () => document.querySelectorAll('[data-sticky-atc]').forEach(wire);
  init();
  document.addEventListener('DOMContentLoaded', init);
}
